<template>

  <div class="col-md-6">
    <div class="card mt-3">
      <div class="card-body">
        <div class="person-header">
          <h4># {{ index + 1 }}</h4>
          <div class="">
<!--            <button v-if="canRemove" type="button" class="btn" aria-label="Close" @click="$emit('remove')">-->
<!--              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">-->
<!--                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>-->
<!--                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>-->
<!--              </svg>-->
<!--            </button>-->
          </div>
        </div>

        <div class="">
          <button v-if="index === 0" class="btn-light btn mt-3 take-data-button" @click.stop.prevent="$emit('loadFromOrder')">Prevziať údaje dojednávajúcej osoby</button>
          <div class="form-group row mt-4">

            <div class="col-sm-4">
              <div class="con">
                <div class="col-12">
                  <label class="label" :for="'person_name'  + index">{{ $t('order.person.name.label') }}
                  </label>
                  <input type="text" class="in in_trv w-input" :id="'person_name' + index" :placeholder="$t('order.person.name.placeholder')" name="companion_name" :class="{ 'is-invalid': v$.formData.name.$error  }"
                         v-model="formData.name">
                  <div class="invalid-feedback">{{$t("validation.required") }}</div>
                </div>
                <div class="col-12">
                  <label class="label" :for="'person_surname' + index">{{ $t('order.person.surname.label') }}

                  </label>
                  <input type="text" class="in in_trv w-input" :id="'person_surname' + index" :placeholder="$t('order.person.surname.placeholder')" name="companion_surname" :class="{ 'is-invalid': v$.formData.surname.$error  }"
                         v-model="formData.surname">
                  <div class="invalid-feedback">{{$t("validation.required") }}</div>
                </div>
              </div>


            </div>
            <label class="label" :for="'person_birthday_date' + index">{{ $t('order.person.birthday_date') }}</label>
            {{ formData.birthday_date }}
            <DatePickerWrap
                :value="formData.birthday_date"
                class-name="companion-birthdate"
                  @input="formData.birthday_date = $event"
                  :min-date="birthdayDateFrom" :error="v$.formData.birthday_date.$error"/>
<!--            <input type="date" v-model="formData.birthday_date" :class="{'in in_trv w-input': true, 'is-invalid': v$.formData.birthday_date.$error  }" />-->
                <div class="invalid-feedback" v-if="v$.formData.birthday_date.required.$invalid">{{$t("validation.required") }}</div>
                <div class="invalid-feedback" v-if="v$.formData.birthday_date.minValue.$invalid">Pre osoby nad 70 rokov prosím zadajte samostatnú prihlášku.</div>


            <div class="cx_sep"></div>






          </div>




          <!--          <div class="form-group row mt-4">-->
          <!--            <label class="col-sm-4" :for="'person_email' + index">{{ $t('order.person.email.label') }}</label>-->
          <!--            <div class="col-sm-8">-->
          <!--              <input type="email" class="form-control" :id="'person_email' + index" :placeholder="$t('order.person.email.placeholder')" name="" v-model="formData.email" :class="{ 'is-invalid': v$.formData.email.$error  }">-->
          <!--              <div class="invalid-feedback">{{$t("validation.email") }}</div>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="form-group row mt-4">-->
          <!--            <label class="col-sm-4" :for="'person_tel' + index">{{ $t('order.person.tel.label') }}</label>-->
          <!--            <div class="col-sm-8">-->
          <!--              <input type="email" class="form-control" :id="'person_tel' + index" :placeholder="$t('order.person.tel.placeholder')" name="" v-model="formData.tel" :class="{ 'is-invalid': v$.formData.tel.$error  }">-->
          <!--              <div class="invalid-feedback">{{$t("validation.tel") }}</div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
//import DatePickerWrap from "@/components/parts/DatePickerWrap";
import '@vuepic/vue-datepicker/dist/main.css';
import useValidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import DatePickerWrap from "@/components/parts/DatePickerWrap.vue";
//import {telRule} from "@/rules";
//
// // Add a rule.
// extend('secret', {
//   validate: value => value === 'example',
//   message: 'This is not the magic word'
//  });

export default {
  name: "TripCompanion",
  data: function () {
    return {
      formData: {
        name: null,
        surname: null,
        birthday_date: null,
        // email: null,
        // tel: null,

      },
      maxAge: 70,

    }
  },

  setup() {
    return {
      v$: useValidate({$autoDirty: true})
    }
  },
  validations: function () {
    return {
      formData: {
        name: {required},
        surname: {required},
        birthday_date: {
          required,
          minValue: function (value) {
            return this.birthdayDateFrom <= new Date(value)
          }
        },
        // email: {required, email},
        // tel: {required, telRule},
      }
    }
  },
  computed: {
    birthdayDateFrom() {
      var d = (this.tripEndsAt && new Date(this.tripEndsAt)) || new Date();
      var year = d.getFullYear();
      var month = d.getMonth();
      var day = d.getDate();

      var c = new Date(year - (this.ageAbove70 ? 150 : this.maxAge), month, day); //150 years or 70
      c.setHours(0,0,0,0);
      return c;
    },

  },
  watch: {
    "person.name": function () {
      this.formData.name = this.person.name;
    },
    "person.surname": function (){
      this.formData.surname = this.person.surname;
    },
    "person.birthday_date": function (){
      this.formData.birthday_date = this.person.birthday_date;
    },
    formData: {
      // This will let Vue know to look inside the array
      deep: true,
      // We have to move our method to a handler field
      handler() {
        this.$emit('changeData', this.formData)
      }
    }

  },
  components: {
    DatePickerWrap
    //DatePickerWrap
  },
  props: {
    index: Number,
    canRemove: Boolean,
    tripEndsAt: String,
    errors: Object,
    ageAbove70: Boolean,
    person: Object,
  },
  mounted(){
    this.$emit('changeData', this.formData)
    //this.formData = this.person;
  }
}
</script>

<style scoped>
.person-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.person-header button{
  border-radius: 50%;
  padding: 0.5em;
}
.btn{
  margin-top: 10px;
  font-size: 1em;
  padding: .5em 1em;
  font-style: normal;
  text-transform: none;

}
</style>